import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-inventory-list',
  templateUrl: './inventory-list.component.html',
  styleUrls: ['./inventory-list.component.scss'],
})
export class InventoryListComponent implements OnInit {
  devices: any;
  buttonDisabled: boolean = false;
  lang : any = '';
  constructor(
   private PS:ProductService,
   private UTS: UtilitiesService,
   private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.lang = this.UTS.getLocaleLanguage();
    this.devices = JSON.parse(localStorage.getItem('selectedDevices')) || [];
  }


  totalAmount(){
    let total :any = 0;
    this.devices.forEach((data:any) => {
      total += data?.listPrice
    });
    return total;
  }


  continue(){
    let commerceItem = {};
    let addedCommerceItem = [];
    if(this.devices?.length > 0){
      this.devices.forEach(data => {
        addedCommerceItem.push({
          catalogRefId:data?.id,
          skuId : data?.id,
          productId:data?.productId,
          quantity:1,
          commerceItemClassType:'configurableCommerceItem',
          useGlobalStock: data?.isInStockStore !== true && (data?.isInStock == 'true' || data?.isInStock == true) ? true : false,
          commerceItemsList:[],  
        })
      });
      commerceItem = {
				commerceItem: addedCommerceItem
			} 
      this.buttonDisabled = true;
       this.PS.addCartMultiple(commerceItem).subscribe((res:any)=>{
         if(res){
          document.location.href = `${document.location.origin}/b2c/heshop/checkoutApp/cart?lang=${this.lang}`;
          localStorage.removeItem('selectedDevices');
        }
       },err=>{
        this.buttonDisabled = false;
         let showmessage =''
        this.translate.get('ADD_to_CARD_AREN_PRO_ERROR').subscribe((message) => {
          showmessage = message;
        });
        if(showmessage){
          this.UTS.ValidationErrorToast(showmessage)
        }
       })
      //service call success and response
    }
  }




}
